import { Outlet } from 'react-router-dom'

import { LocationsForBookingsDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import BookingsDatatable from 'modules/space_control/components/BookingsDatatable'

const BookingsPage = () => {
  useEffect(() => {
    track(trackingEvents.spaceControl.seeBookings)
  }, [])

  const { error, loading, data } = useQuery(LocationsForBookingsDocument)

  const locations = data ? data.locations.locations : []
  const accesses = data?.apiCore?.accesses ?? []
  const canEditEverybody = data?.spaceControl?._policies?.bookingEditEverybody?.can ?? false
  const canEditSelf = data?.spaceControl?._policies?.bookingEditSelf?.can ?? false
  const canCancelEverybody = data?.spaceControl?._policies?.bookingCancelEverybody?.can ?? false
  const canCancelSelf = data?.spaceControl?._policies?.bookingCancelSelf?.can ?? false

  return (
    <ResponsivePage.Body loading={loading} showHeader={false} error={error}>
      <BookingsDatatable
        locations={locations}
        accesses={accesses}
        canEditEverybody={canEditEverybody}
        canEditSelf={canEditSelf}
        canCancelEverybody={canCancelEverybody}
        canCancelSelf={canCancelSelf}
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default BookingsPage
